import { PortfolioNft, SUPPORTED_NETWORKS } from "@cede/types";

export function getRaribleNftUrl(nft: PortfolioNft) {
  if (nft.network === SUPPORTED_NETWORKS.ETH) {
    return `https://rarible.com/token/${nft.tokenAddress}:${nft.tokenId}`;
  }

  if (nft.network === SUPPORTED_NETWORKS.IMX) {
    return `https://rarible.com/token/immutablex/${nft.tokenAddress}`;
  }

  return null;
}
